import React, {useState} from "react"
import axios from 'axios'
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


const Forms = props => {


  const [loading, setLoading] = React.useState(true);
  const [deleting, setDeleting] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [deleteThis, setDeleteThis] = React.useState(null);

  const toggleDel = () => setDeleteThis(null);

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_FORMS+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
        if(response.status == 200) {
          setData(response.data);
          setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  React.useEffect(()=>{
    if(props.filterBlock) {
    fetchData();
    }
  }, [props.filterBlock]);


  const columns = [{
    dataField: 'slno',
    text: '#'
  }, {
    dataField: 'name',
    text: 'Form Name',
    sort: true,
    filter: textFilter(),
  }, {
    dataField: 'description',
    text: 'Form Description',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'id',
    text: 'Actions',
    formatter: (cell, row, rowIndex)=> {
      return <div className="d-flex">
        <Link className="btn" to={{pathname: "/form", state: {id: row.id}}}>
        <i className="bx bx-info-circle" style={{color: '#667CE8', fontSize: 19,}}></i></Link>{' '}
        <Link className="btn" to={{pathname: "/forms/edit/"+row.id, query: row}}>
          <i className="bx bx-pencil" style={{color: '#667CE8', fontSize: 19,}}></i>
        </Link>{' '}
        <Button color="link" title="Delete" onClick={()=>{
        setDeleteThis(row);
        }}><i className="bx bx-trash" style={{color: 'rgb(231, 119, 147)', fontSize: 19,}}></i></Button>
      </div>;
    },
    csvExport: false,
  },
  
  // {
  //   text: 'Actions',
  //   formatter: (cell, row, rowIndex)=> {
  //     return <div className="d-flex">
  //       <Link className="btn btn-light me-2" to={{pathname: "/form", state: {id: row.id}}}>View</Link>{' '}
  //       <Link className="btn btn-light" to={{pathname: "/forms/edit/"+row.id, query: row}}>Edit</Link>{' '}
  //       {/* <Button color="link" onClick={()=>{
  //       console.log('Edit : '+row.id);
  //       }}>Edit</Button>
  //       {' '} */}
  //     </div>;
  //   }
  // },
  ];
  
  const handleDelete = () => {
    let formdata = {
      id: deleteThis.id,
    };
    setDeleting(true);
    post(url.DELETE_FORM, formdata)
    .then((response) => {
      console.log('DEL RESP', response);
      if(response.status == 200) {
        cogoToast.success('Form deleted');
        setDeleteThis(null);
        fetchData();
      }
      else if(response.status == 409) {
        cogoToast.error('Form could not be deleted as it is being used for activities/tasks');
      }
      else {
        console.log('err::', response);
        cogoToast.error('Form could not be deleted');
      }
      setDeleting(false);
    }, (error) => {
      console.log(error);
      cogoToast.error('Form could not be deleted');
      setDeleting(false);
    });

  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Forms | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Forms ({data.length})</h3>
            <Link className="btn btn-primary" to={{pathname: "/forms/new", query: {id: 'new'}}}>Create New</Link>
          </div>
    
          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <BootstrapTable keyField='id' data={ data } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory() } />
            </CardBody>
          </Card>

        </Container>
      </div>


      { deleteThis !== null &&
      <Modal isOpen={deleteThis !== null} centered>
        <ModalHeader toggle={toggleDel}>Confirmation</ModalHeader>
        <ModalBody>
          Are you sure you want to delete {deleteThis.name}?
          <br />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={deleting} onClick={handleDelete}>Delete</Button>{' '}
          <Button color="link" onClick={toggleDel}>Cancel</Button>
        </ModalFooter>
      </Modal>}
      
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
  } = state.filters
  return { filterBlock }
}

export default connect(mapStatetoProps)(Forms)